export enum DateColumn {
  EventDate = "event_date",
}
